const NLI_CONSTANTS = {
    NLI_URL_END: "/nli",
    IMOBILE_URL_END: "/nli",
  
    NLI_URL_PATH: '/servicing/nli',
  
    // Common Page Path
    NLI_ERROR_PATH: "/servicing/nli/nliError",
    NLI_SUCCESS_PATH: "/servicing/nli/nliSuccess",
    NLI_DUPLICATE_PATH: "/servicing/nli/nli-success",
  
    // PROPERTYSEARCH
    NLI_PROPERTY_SEARCH_PATH: "/servicing/nli/propertySearch",
  
    // GDPR
    NLI_GDPR_HOME_PATH: "/servicing/imobileservice/loadNliGdpr",
    NLI_GDPR_PATH: "/servicing/imobileservice/gdpr",
    NLI_GDPR_CHECK_CUSTOMER_PATH: "/servicing/imobileservice/checkCustomer",
  
    // CREDIT CARD QRCODE EMI
    NLI_CREDITCARD_EMI_CHECK_PATH: "/servicing/nli/makepayment/creditCard",
  
    // FEEDBACK
    NLI_FEEDBACK_PATH: "/servicing/nli/feedback",
    NLI_FEEDBACK_EXPERIENCE_PATH: "/servicing/nli/feedbackExperience",
    NLI_FEEDBACK_NPS_FORM_PATH: "/servicing/nli/feedbackNPSForm",
  
    // FOREX INSTA BANKING
    NLI_FOREX_INSTA_PATH: "/servicing/nli/forexInstaBanking",
    NLI_DETAILS_RESPONSE_PATH: "/servicing/nli/detailsResponse",
  
    // FOREX REQUEST BANKING
    NLI_FOREX_REQ_PATH: "/servicing/nli/forexRequest",
  
    // SERVICE REQUEST
    NLI_SR_CONFIRMATION_PATH: "/servicing/nli/SRconfirmation",
    NLI_SR_REQUEST_FORM_PATH: "/servicing/nli/srRequestForm",
  
    // TPU FUNDS
    NLI_CASH_DEPOSIT_PATH: "/servicing/nli/cashDeposit",
  
    // CAR LOAN DASHBOARD
    NLI_TRACK_MY_LOAN_LOGIN_PATH: "/servicing/nli/trackMyLoanLogin",
    NLI_CAR_LOAN_DASHBOARD_PATH: "/servicing/nli/carLoanDashboard",
  
    // COMMON SUBMIT
    NLI_SUBMITTED_RESPONSE_PAGE_PATH: "/servicing/nli/submittedResponsePage",
  
    // LOAN TRACKER
    NLI_LOAN_TRACKER_PATH: "/servicing/nli/loanTracker",
  
    // GRIEVANCE FORM
    NLI_GRIEVANCE_FORM_PATH: "/servicing/nli/grievanceForm",
    NLI_SUBMIT_GRIEVANCE_PATH: "/servicing/nli/submitGrievanceForm",
    NLI_GRIEVANCE_TWO_FORM_PATH: "/servicing/nli/grievanceFormTwo",
    NLI_GRIEVANCE_FORM_THREE_PATH: "/servicing/nli/grievanceFormThree",
  
    // BLUEDART
    NLI_BLUEDART_PATH: "/servicing/nli/bluedart",
  
    // PREPAID CARD
    NLI_PREPAID_HOME_PATH: "/servicing/nli/prepaidHome",
    NLI_PREPAID_FORM_PATH: "/servicing/nli/prepaid",
    NLI_PREPAID_KYC_PATH: "/servicing/nli/prepaidKycProcess",
    NLI_PREPAID_APPLICATION_PROCESS_PATH: "/servicing/nli/prepaidApplicationProcess",
    NLI_PREPAID_EMAIL_VERIFICATION_PATH: "/servicing/nli/prepaidEmailVerification",
    NLI_PREPAID_DASHBOARD_PATH: "/servicing/nli/prepaidDash",
  
    // AURA ACCOUNT
    NLI_AURA_LOGIN_FORM_PATH: "/servicing/nli/auraLogin",
    NLI_AURA_ACCOUNT_PATH: "/servicing/nli/auraAccount",
    NLI_AURA_SUBMIT_PATH: "/servicing/nli/auraSubmit",
  
    // OFFER PORTAL
    NLI_OFFER_PORTAL_LOGIN_PATH: "/servicing/nli/offerPortalLogin",
  
    // NRI FORM
    NLI_NRI_FORM_PATH: "/servicing/nli/nriForm",
  
    // SHOW FUND TRANSFER SLIP
    NLI_SHOW_FUND_TRANSFER_SLIP_PATH: "/servicing/nli/showFundTransferSlip",
  
    // COMPLIMENTS
    NLI_COMPLIMENTS_PATH: "/servicing/nli/compliments",
  
    // EMV
    NLI_EMV_PATH: "/servicing/nli/emv",
  
    // TRACK SHIPMENT
    NLI_TRACK_SHIPMENT_PATH: "/servicing/nli/trackShipment",
  
    // KYC
    NLI_KYC_PATH: "/servicing/nli/kyc",
  
    // NSE
    NLI_NSE_TICKER_PATH: "/servicing/nli/nseTicker",
  
    // EASY POS
    NLI_EASY_POS_PATH: "/servicing/nli/easyPos",
    NLI_SUBMIT_POS_PATH: "/servicing/nli/submitPOS",
  
    // UNCLAIMED DIVIDENT
    NLI_UNCLAIMED_DIVIDENTS_PATH: "/servicing/nli/unclaimedDividents",
    NLI_UNCLAIMED_DIVIDENTS_LIST_PATH: "/servicing/nli/unclaimedDividentList",
  
    // INVESTOR UPLOAD NLI
    NLI_INVESTOR_UPLOAD_PATH: "/servicing/nli/investorUpload",
  
    // SHAREHOLDER
    NLI_SHARE_HOLDER_FORM_PATH: "/servicing/nli/shareHolderForm",
  
    // UNCLAIMED DEPOSIT
    NLI_UNCLAIMED_DEPOSIT_PATH: "/servicing/nli/unclaimedDeposit",
    NLI_UNCLAIMED_DEPOSIT_ACCOUNT_DETAIL_PATH: "/servicing/nli/unclaimedDepositAccountDetail",
  
    // GRID CARD AUTHENTICATION
    NLI_GRID_CARD_LOGIN: '/servicing/nli/gridCardLogin',
    NLI_GRID_CARD_AUTHENTICATION:'/servicing/nli/gridCardAuthentication',
  
    //ENACH
    NLI_ENACH_FORM: '/servicing/nli/enachForm',
    
    // DONATIONFORM
    NLI_DONATION_FORM_LOGIN: '/servicing/nli/donationForm',
    NLI_PREVIEW_DONATION_FORM: '/servicing/nli/previewDonationForm',
  
    // CASH KARO
    NLI_CASH_KARO_LOGIN: '/servicing/nli/cashKaroLogin',
  
    // LOAN QRCODE EMI
    NLI_LOAN_EMI_CHECK_PATH: "/servicing/nli/makepayment/loans",
  
    // VIDEO KYC Login
    NLI_VIDEO_KYC_FORM: '/servicing/nli/vKYCAuthentication',

    // DISCREPANT
    DISCREPANT_HOME: '/servicing/nli/uploadDiscrepantDocumentsHome',
    DISCREPANT_AUTH: '/servicing/nli/uploadDiscrepantDocumentsAuthentication',
    DISCREPANT_SUCCESS: '/servicing/nli/uploadDiscrepantDocumentSuccess',
  };
  
  export default NLI_CONSTANTS;
  